import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"

import { Row, Col, CardBody, Card, Alert, Container, Label, Button, Spinner } from "reactstrap"
import Select from "react-select"

//redux
import { useSelector } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

//Social Media Imports
import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"




// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo/cargills.png"
//import logo from "assets/images/logo/mySky_GO.png" //"assets/images/globe-trans.png"
import config from "../../config"
import { ActiveClient } from "../../config"
//
import { Text } from "framework/validators/TextValidation"


//Import config


//Import firebase
// import firebase from "firebase/app"
// import 'firebase/auth'
//import { getAuth,GoogleAuthProvider,FacebookAuthProvider,OAuthProvider } from 'firebase/auth';
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import 'firebase/auth'
import { googleProvider, facebookProvider, msProvider, appleProvider, yahooProvider, twitterProvider } from '../../FirebaseConstants';
//import { GoogleAuthProvider } from "firebase/auth";
import DPOTP from "../../framework/components/DPOTP"
import { useHistory } from 'react-router-dom';
import SplashScreenCargills from "./SplashScreenCargills"
import ApiService from "api/apiService"


const Login = props => {

  const [strUsername, setUsername] = useState('')
  const [strPassword, setPassword] = useState('')
  const [selectedGroup, setselectedGroup] = useState(null)
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [buttonshow, setButtonshow] = useState(false)
  const [uitype, setUitype] = useState('')
  const [resetUsername, setResetUsername] = useState('')
  const [usernameEnable, setUsernameEnable] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [loading, setLoading] = useState(false);
  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  // This useEffect is used to set the key to 1 after 1 second when the ActiveClient is changed
  // This will re-render the component and the logo will be changed
  const [key, setKey] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setKey(1)
    }, 1000);
  }, [ActiveClient]);

  // This useEffect is used to set the key to 1 after 1 second when the ActiveClient is changed
  // This will re-render the component and the logo will be changed

  let history = useHistory();

  const [optionGroup, setoptionGroup] = useState([
    {
      options: []
    }
  ]);

  useEffect(() => {
    async function fetchPing() {

      try {
        // Use ApiService to make the GET request
        const response = await ApiService.get(`ping`, {}, false); // false for non-authenticated request

        // Log the response data
        console.log(response);
      } catch (error) {
        console.error('Error fetching ping:', error);
      }
    }

    fetchPing();
  }, []);



  useEffect(() => {

    if (optionGroup && optionGroup.length == 1) {
      setselectedGroup(optionGroup[0].value);
    }
  }, [optionGroup]);


  function handleSelectGroup(e) {
    setselectedGroup(e['value'])
  }


  const loadLocDrop = async (userName, password) => {
    try {

      // Set loading state if necessary
      setLoading(true);

      const requestBody = {
        UserName: userName,
        Password: password,
      };

      // Use ApiService to make the POST request
      const response = await ApiService.post('Locations/login/locations', requestBody, false); // false for non-authenticated request

      if (response.status === 200) {
        // Assuming response.data contains the success flag and data
        setoptionGroup(response.data.success ? response.data.data : []);
        setselectedGroup("");
      } else {
        // Handle non-2xx HTTP status codes
        console.error(`Request failed with status ${response.status}`);
        setoptionGroup([]);
        setselectedGroup("");
      }
    } catch (error) {
      // Handle any other errors, including network or API issues
      console.error('Error:', error.message);
      setoptionGroup([]);
      setselectedGroup("");
    } finally {
      // Set loading to false when the API call is completed
      setLoading(false);
    }
  };



  const handleValidSubmit = async (event, values) => {
    if (selectedGroup == null) {
      setAlertColor("danger");
      setAlertMsg("Please select Location !");
      setShow(true);
      return;
    }

    try {
      // Set loading to true when starting the API call
      setLoading(true);

      const requestBody = {
        "strUsername": strUsername,
        "strPassword": strPassword,
        "strLocation": selectedGroup,
      };

      // Use ApiService to make the POST request
      const response = await ApiService.post(`login`, requestBody, false);
      switch (response.status) {
        case 200:
          localStorage.setItem("authUser", JSON.stringify(response.data.data));  // Assuming response.data has user data
          localStorage.setItem("authToken", response.data.token); // Assuming response.token has the auth token
          if (localStorage.getItem("authPark")) {
            localStorage.removeItem("authPark");
          }
          getLicenseDetails();
          break;

        case 403:
          setAlert("danger", "Invalid Access to Location !");
          break;

        case 404:
          setAlert("danger", response.data.msg);
          if (response.data.msg === "Required Reset" || response.data.msg === "Password Expired") {
            setResetUsername(strUsername);
            setButtonshow(true);
          } else if (response.data.msg === "Locked") {
            // Use ApiService to get user policy data
            const userPolicyResponse = await ApiService.get(`common/userpolicy/${strUsername}`, {}, true);

            if (userPolicyResponse.status) {
              setAlertMsg(`Your account is locked. Account will be unlocked after ${userPolicyResponse.data.data[0].unblockAt.slice(0, 10)} at ${userPolicyResponse.data.data[0].unblockAt.slice(11, 16)}`);
            } else {
              setAlertMsg("Your account is locked. Please contact your administrator.");
            }
          }
          setShow(true);
          break;

        case 400:
          setAlert("danger", "Unexpected error!");
          setShow(true);
          break;

        default:
          setAlertMsg(response.msg);
          break;
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      // Set loading to false when the API call is completed
      setLoading(false);
    }

    function setAlert(color, message) {
      setAlertColor(color);
      setAlertMsg(message);
      setShow(true);
    }
  };


  function search(selectedGroup, optionGroup) {
    //debugger;
    for (var i = 0; i < optionGroup.length; i++) {
      if (optionGroup[i].value == selectedGroup) {
        return optionGroup[i]["label"];
      }
    }
  }

  const loadLocations = async (userName, password) => {

    if (userName == "" || password == "") {
      setAlertMsg("Please enter username and password !");
      setAlertColor("danger");
      setShow(true);
      return;
    }

    loadLocDrop(userName, password)
    return
  }


  const getLicenseDetails = async () => {

    try {
      const response = await ApiService.get(`client`, {}, true); // true for authenticated request

      // Handle different HTTP status codes here - this will now work with our Axios configuration
      switch (response.status) {
        case 200:
          if (response.data && response.data.success) {
            localStorage.setItem("Serial", response.data.data.strSerial);
            setIsLoad(true);
            setTimeout(() => {
              setIsLoad(false);
              history.push("/");  // Redirect to home or desired page
            }, 3000);
          } else {
            handleLicenseError(response?.data?.msg || "License verification failed");
          }
          break;
        case 404:
          handleLicenseError(response?.data?.msg || "License not found");
          break;
        default:
          handleLicenseError(response?.data?.msg || "License verification failed with unexpected status");
          break;
      }
    } catch (error) {
      handleLicenseError(error.toString());
    } finally {
      setTimeout(() => {
        setShow(false)
      }, 10000);
    }
  };

  // Helper function to handle license errors
  const handleLicenseError = (errorMsg) => {
    setAlertMsg(errorMsg || "License verification failed");
    setAlertColor("danger");
    setShow(true);
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    history.push("/login");
  };


  return (

    <React.Fragment >
      {
        isLoad == false ? <MetaTags>
          <title>Login</title>
        </MetaTags> : null}
      {
        isLoad == false ? <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                </Alert>
              ) : null}
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col xs={7}>
                        <div className="text-primary p-4">
                          <h5 className="text-primary">{`Welcome to ${config[config.ActiveClient].companyName}!`}</h5>
                          <p>{`Sign in to continue to ${config[config.ActiveClient].loginUIMessage}.`}</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="70"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-0">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v)
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <AvField
                            name="username"
                            label="Username"
                            value={strUsername}
                            className="form-control"
                            placeholder="Enter username"
                            type="username"
                            onChange={(e) => {
                              setUsername(Text(e.target, 10, true, false, "upper", false))
                              setShow(false)
                            }}
                            // onBlur={async (e) => {
                            //   loadLocations(e.target.value)
                            // }}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="password"
                            label="Password"
                            value={strPassword}
                            type="password"
                            required
                            placeholder="Enter Password"
                            onChange={(e) => {
                              let val2 = Text(e.target, 16, true, true, "normal", false);
                              setPassword(val2)
                            }}
                            onBlur={(e) => {
                              loadLocations(strUsername, e.target.value)
                            }}
                          />
                        </div>
                        {<div className="mb-3">
                          <Label>Select Location</Label>
                          <Select
                            autoFocus
                            backspaceRemovesValue={false}
                            value={selectedGroup}
                            placeholder={selectedGroup ? search(`${selectedGroup}`, optionGroup) : 'Select Here..'}
                            onChange={handleSelectGroup}
                            options={optionGroup}
                          />
                        </div>}

                        {/* <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div> */}
                        {/* 
                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                          //type="button"
                          //onClick={btnLogin}
                          >
                            Log In
                          </button>
                        </div> */}


                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit" // Make sure the button type is "submit" for form submission
                            disabled={loading} // Disable the button while loading
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm" className="ms-2" color="light" />
                              </>
                            ) : (
                              "Log In"
                            )}
                          </button>
                        </div>



                        <div className="mt-4 text-center ">
                          <Label onClick={(e) => {
                            setButtonshow(true)
                            setUitype("forgot")
                            setUsernameEnable(true)
                          }} className="text-muted" style={{ cursor: 'pointer' }}>
                            <i className="mdi mdi-lock me-1" style={{ cursor: 'pointer' }} />
                            Forgot your password?
                          </Label>
                        </div>
                      </AvForm>
                    </div>

                    <div className="mt-5 text-center">
                      <p style={{ display: "none" }}>
                        Don&#39;t have an account ?{" "}
                        <Link to="register" className="fw-medium text-primary">
                          {" "}
                          Signup now{" "}
                        </Link>{" "}
                      </p>
                      <p>
                        © {new Date().getFullYear()} <a href={config[config.ActiveClient].webUrl}>{config[config.ActiveClient].fullName}</a>{" "}
                      </p>
                      <p>
                        Version {process.env.REACT_APP_VERSION}
                      </p>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <DPOTP
            confirm_both={buttonshow}
            onCancel={() => {
              setButtonshow(false)
            }}
            uitype={uitype}
            usercode={resetUsername}
            usernameEnable={usernameEnable}
            setUsernameEnable={setUsernameEnable}
          />
        </div> :
          <SplashScreenCargills />}
    </React.Fragment >
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
